import { HttpMethod } from "../../common/constants/http-requests";
import { httpRequest } from "../../common/utils/http-request";
import { PROJECT_ALLOCATION_API } from "../api";

export const getProjectAllocationDetails = (pageNo, pageSize, sortDir, sortBy, searchData, status, employeeID) =>
  httpRequest({
    url: `${PROJECT_ALLOCATION_API}/get-assigned-projects?page=${pageNo}&pagesize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchKey=${searchData}&status=${status}&employeeID=${employeeID}`,
    method: HttpMethod.GET,
  });

export const getUsersProjectAllocationDetails = (payload) =>
  httpRequest({
    url: `${PROJECT_ALLOCATION_API}/get-project-allocations`,
    method: HttpMethod.POST,
    data: payload
  })

export const getProjectAllocationSummary = (projectId) =>
  httpRequest({
    url: `${PROJECT_ALLOCATION_API}/get-project-allocation-summary/${projectId}`,
    method: HttpMethod.GET,
  })